<template>
  <div class="transaction-container">
    <Header />
    <AccountDetail />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import AccountDetail from '@/components/AccountDetail.vue';

export default {
  components: {
    Header,
    AccountDetail
  }
};
</script>

<style>
.transaction-container {
  width: 100%;
  margin: 0 auto;
}
</style>
